/* ============================================================
   NLO THEME — events.js
   Gallery lightbox
   ============================================================ */
'use strict';

// ── Gallery Lightbox ──────────────────────────────────────
class NLOLightbox {
  constructor() {
    this.modal    = document.getElementById('lightbox-modal');
    this.img      = this.modal?.querySelector('.lightbox__image');
    this.caption  = this.modal?.querySelector('.lightbox__caption');
    this.counter  = this.modal?.querySelector('.lightbox__counter');
    this.prevBtn  = this.modal?.querySelector('.lightbox__prev');
    this.nextBtn  = this.modal?.querySelector('.lightbox__next');
    this.closeBtn = this.modal?.querySelector('.nlo-modal__close');
    this.overlay  = this.modal?.querySelector('.nlo-modal__overlay');
    this.images   = [];
    this.current  = 0;
    if (this.modal) this.init();
  }
  init() {
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click',  () => this.close());
    this.prevBtn?.addEventListener('click',  () => this.go(this.current - 1));
    this.nextBtn?.addEventListener('click',  () => this.go(this.current + 1));
    document.addEventListener('keydown', e => {
      if (!this.modal?.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft')  this.go(this.current - 1);
      if (e.key === 'ArrowRight') this.go(this.current + 1);
      if (e.key === 'Escape')     this.close();
    });
    // Touch swipe
    let startX = 0;
    this.modal?.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.modal?.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) this.go(diff > 0 ? this.current + 1 : this.current - 1);
    });
  }
  open(images, startIndex) {
    this.images  = images;
    this.current = startIndex || 0;
    this.render();
    this.modal?.classList.add('is-open');
    this.modal?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  close() {
    this.modal?.classList.remove('is-open');
    this.modal?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  go(index) {
    this.current = ((index % this.images.length) + this.images.length) % this.images.length;
    this.render();
  }
  render() {
    const item = this.images[this.current];
    if (this.img)     { this.img.src = item.src; this.img.alt = item.caption || ''; }
    if (this.caption) this.caption.textContent = item.caption || '';
    if (this.counter) this.counter.textContent = `${this.current + 1} / ${this.images.length}`;
    if (this.prevBtn) this.prevBtn.style.display = this.images.length > 1 ? '' : 'none';
    if (this.nextBtn) this.nextBtn.style.display = this.images.length > 1 ? '' : 'none';
  }
}

const lightbox = new NLOLightbox();

document.querySelectorAll('.js-lightbox-trigger').forEach((el, i) => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const gallery = el.closest('[data-lightbox-group]');
    let images, startIndex;
    if (gallery) {
      const triggers = Array.from(gallery.querySelectorAll('.js-lightbox-trigger'));
      images     = triggers.map(t => ({ src: t.dataset.src || t.querySelector('img')?.src, caption: t.dataset.caption || '' }));
      startIndex = triggers.indexOf(el);
    } else {
      images     = [{ src: el.dataset.src || el.querySelector('img')?.src, caption: el.dataset.caption || '' }];
      startIndex = 0;
    }
    lightbox.open(images, startIndex);
  });
});
